// For Making Faq Show More Btn On Product Page
document.addEventListener("DOMContentLoaded", function () {
  const LIMIT = 5;

  document.querySelectorAll(".faq-wrapper").forEach(function (wrapper) {
    const btn = wrapper.querySelector(".faq-show-more-btn");
    if (!btn) return;

    const allFaqs = Array.from(wrapper.querySelectorAll("collapsible-tab.m-collapsible"));
    if (allFaqs.length <= LIMIT) return;

    // Ensure initial state: hide > LIMIT
    allFaqs.forEach((faq, i) => {
      if (i >= LIMIT) faq.classList.add("faq-hidden");
    });

    btn.addEventListener("click", function () {
      const expanded = btn.getAttribute("aria-expanded") === "true";

      if (!expanded) {
        // SHOW MORE
        allFaqs.forEach((faq, i) => {
          if (i >= LIMIT) faq.classList.remove("faq-hidden");
        });
        btn.textContent = "Show less";
        btn.setAttribute("aria-expanded", "true");
      } else {
        // SHOW LESS (hide extras)
        allFaqs.forEach((faq, i) => {
          if (i >= LIMIT) {
            // Optional: close if opened
            const content = faq.querySelector("[data-content]");
            if (content && !content.hasAttribute("hidden")) {
              content.setAttribute("hidden", "");
            }
            faq.classList.add("faq-hidden");
          }
        });

        btn.textContent = "Show more";
        btn.setAttribute("aria-expanded", "false");

        // optional: scroll back to top of FAQ list nicely
        wrapper.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });
}); 



// For Making Header transparent on About Page
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.m-header');

  // About page detect
  if (document.body.classList.contains('template-about-us-3')) {
    header.classList.add('transparent-on-top');

    window.addEventListener('scroll', function () {
      if (window.scrollY > 20) {
        header.classList.remove('transparent-on-top');
      } else {
        header.classList.add('transparent-on-top');
      }
    });
  }
});
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.m-header');

  // From Nature to you page detect
  if (document.body.classList.contains('from-nature-to-you')) {
    header.classList.add('transparent-on-top');

    window.addEventListener('scroll', function () {
      if (window.scrollY > 20) {
        header.classList.remove('transparent-on-top');
      } else {
        header.classList.add('transparent-on-top');
      }
    });
  }
});


// subify-powered-text ko hid
   setTimeout(function () {
        $(".subify-powered-text").hide();
    }, 3000); // 3000ms = 3 seconds




// Pre Order Functionality

if (document.body.classList.contains('pre-order')) {
  $(".m-add-to-cart .m-add-to-cart--text").html("Pre Order Now");
}

if (document.body.classList.contains('product-nutraone-membership')) {
  $(".m-add-to-cart .m-add-to-cart--text").html("Start Your Membership");
}

(function () {

  const isPreorderTemplate = document.body.classList.contains('pre-order');
  const isMembershipTemplate = document.body.classList.contains('product-nutraone-membership');
  const skipPurchaseType = document.body.classList.contains('custom-single-product') || document.body.classList.contains('skincare-layout-2');
  // ================================
  // CHECK IF SUBSCRIPTION IS SELECTED
  // ================================
  function isSubscriptionSelected() {

    return document.querySelector(
      ".subify-minimal-option.active #subify-widget-subscription-text"
    );

  }

  // ================================
  // GET DELIVERY FREQUENCY
  // ================================
  function getSubscriptionFrequency() {

    if (!isSubscriptionSelected()) return null;

    const frequencyEl = document.querySelector(
      ".subify-minimal-option.active .subify-minimal-dropdown-value"
    );

    if (!frequencyEl) return null;

    return frequencyEl.textContent.trim();

  }

  // ================================
  // MEMBERSHIP TIER
  // ================================
  function getMembershipTier() {

    const activeTier = document.querySelector(".membership-tier.active");

    if (!activeTier) return null;

    return activeTier.textContent.trim().toLowerCase();

  }

  // ================================
  // INJECT PROPERTIES
  // ================================
  function injectProperties(form) {

    // Remove old properties first
    form.querySelectorAll('.preorder-prop').forEach(el => el.remove());

    const frequency = getSubscriptionFrequency();
    const membershipTier = getMembershipTier();

    let purchaseType = "One-time";

    // ================================
    // SUBSCRIPTION PLANS
    // ================================
    const subscriptionPlans = {
      "Every 30 days": {
        type: "Every 30 Days Subscription"
      },
      "Every 60 days": {
        type: "Every 60 Days Subscription"
      },
      "Every 90 days": {
        type: "Every 90 Days Subscription"
      }
    };

    // ================================
    // MEMBERSHIP DISCOUNTS
    // ================================
    const membershipDiscounts = {
      "gold membership": "30%",
      "silver membership": "20%",
      "bronze membership": "10%"
    };

    // ================================
    // SUBSCRIPTION DETECTION
    // ================================
    if (subscriptionPlans[frequency]) {

      purchaseType = subscriptionPlans[frequency].type;

    }

    // ================================
    // CREATE HIDDEN INPUT
    // ================================
    function createInput(name, value) {

      const input = document.createElement("input");

      input.type = "hidden";
      input.name = `properties[${name}]`;
      input.value = value;
      input.classList.add("preorder-prop");

      return input;

    }

    // ================================
    // MEMBERSHIP PRODUCTS
    // ================================
    if (isMembershipTemplate) {

      if (membershipTier && membershipDiscounts[membershipTier]) {

        form.appendChild(createInput("Membership Tier", membershipTier));

        form.appendChild(
          createInput(
            "Membership Benefit",
            `${membershipDiscounts[membershipTier]} discount on all supplements`
          )
        );

      }

    }

    // ================================
    // PREORDER PRODUCTS
    // ================================
    else if (isPreorderTemplate) {

      form.appendChild(createInput("Preorder", "Pre-order Item"));

      form.appendChild(createInput("Purchase Type", purchaseType));

      form.appendChild(
        createInput(
          "Delivery Time",
          "🚚 Delivery Within 90 Days (Preorder Item)"
        )
      );

    }

    // ================================
    // NORMAL PRODUCTS
    // ================================
    else {

      if (!skipPurchaseType) {
        form.appendChild(createInput("Purchase Type", purchaseType));
      }

    }

  }

  // ================================
  // FORM SUBMIT
  // ================================
  document.addEventListener("submit", function (e) {

    const form = e.target;

    if (!form.matches('form[action*="/cart/add"]')) return;

    injectProperties(form);

  }, true);

})();
 




// Slick Sliders
$(document).ready(function(){
  var isArabic = $('body').hasClass('is-ar');

  $('.keyword-pills').slick({
    slidesToShow: 4.1,
    infinite: false,
    speed: 600,
    autoplay: false,
    autoplaySpeed: 6000,
    arrows: false,
    dots: false,
    rtl: isArabic, // 👈 RTL only when body has .is-ar
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 4.1 } },
      { breakpoint: 768, settings: { slidesToShow: 3.8 } },
      { breakpoint: 480, settings: { slidesToShow: 2.1 } }
    ]
  });



$('.product-ingredient-sec .m-mixed-layout__inner').slick({
  slidesToShow: 5,
  infinite: false,
  speed: 600,
  autoplay: false,
  autoplaySpeed: 6000,
  arrows: false,
  rtl: isArabic, // 👈 RTL only when body has .is-ar
  dots: true,
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 4 } },
    { breakpoint: 768, settings: "unslick" }
  ]
});

$('.template-product.supplement-single-product .product-ingredient-sec .m-mixed-layout__inner').slick({
  slidesToShow: 5,
  infinite: false,
  speed: 600,
  autoplay: false,
  autoplaySpeed: 6000,
  arrows: false,
  rtl: isArabic, // 👈 RTL only when body has .is-ar
  dots: true,
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 4 } },
    { breakpoint: 768, settings: { slidesToShow: 3 } },
    { breakpoint: 550, settings: { slidesToShow: 2 } }
  ]
});
$('.template-product.supplement-single-product .reason-section .m-mixed-layout__inner').slick({
  slidesToShow: 5,
  infinite: false,
  speed: 600,
  autoplay: false,
  autoplaySpeed: 6000,
  arrows: false,
  rtl: isArabic, // 👈 RTL only when body has .is-ar
  dots: true,
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 4 } },
    { breakpoint: 768, settings: { slidesToShow: 3 } },
    { breakpoint: 550, settings: { slidesToShow: 2 } }
  ]
});

});


// Home Circle Categories

function initCategorySlider(section) {
    const $slider = $(section).find('.js-mm-category-slider');

    if ($slider.length && !$slider.hasClass('slick-initialized')) {

      $slider.on('init', function () {
        this.style.visibility = "visible";
      });

      $slider.slick({
        slidesToShow: 7.25,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 6000,  
        speed: 500,
        responsive: [
          { breakpoint: 1400, settings: { slidesToShow: 6.25 } },
          { breakpoint: 1025, settings: { slidesToShow: 5, dots: true } },
          { breakpoint: 768, settings: { slidesToShow: 3.25, dots: true, infinite: false,  arrows: false, autoplay: false } }
        ]
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCategorySlider(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCategorySlider(event.target);
  });


// GSAP Animation for Bottle Cap Opening

(function () {
  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  const scene = document.querySelector(".pill-bottle-scene");
  if (!scene) return;

const tl = gsap.timeline({
  scrollTrigger: {
    trigger: scene,
    start: "center 75%",   
    end: "+=300",           
    scrub: true,
    pin: true,
    pinSpacing: true
  }
});

  tl.to(".pb-cap", {
    y: -120,
    x: 70,
    rotate: 18,
    duration: 1
  }, 0);

  tl.to(".pb-tablets", {
    y: -150,
    opacity: 1,
    scale: 1,
    duration: 1
  }, 0.15);

  tl.to(".pb-tablets", {
    x: -25,
    y: -185,
    rotate: -6,
    duration: 1
  }, 0.55);
})();










// EASY BUNDLES ARABIC TRANSLATION
 
(function () {
  const MAP = [
    { en: "Save 10%", ar: "وفر 10٪" },
    { en: "Buy it together Get 10% Off", ar: "اشترِ معاً واحصل على خصم 10٪" },
    { en: "Add the bundle to cart", ar: "أضف الباقة إلى السلة" }
    // Total ko yahan add mat karo
  ];

  const isArabic = () => document.body.classList.contains("is-ar");

  function walkDeep(root, visit) {
    const stack = [root];
    const seen = new Set();
    while (stack.length) {
      const node = stack.pop();
      if (!node || seen.has(node)) continue;
      seen.add(node);

      visit(node);

      if (node.nodeType === 1 && node.shadowRoot) stack.push(node.shadowRoot);

      const kids = node.childNodes;
      if (kids && kids.length) {
        for (let i = kids.length - 1; i >= 0; i--) stack.push(kids[i]);
      }
    }
  }

  function translate(str, toAr) {
    let out = str;
    for (const item of MAP) {
      out = toAr
        ? out.split(item.en).join(item.ar)
        : out.split(item.ar).join(item.en);
    }
    return out;
  }

  function apply() {
    const toAr = isArabic();

    walkDeep(document.documentElement, (node) => {
      if (node.nodeType !== 3) return;
      const v = node.nodeValue;
      if (!v || !v.trim()) return;

      let match = false;
      for (const item of MAP) {
        if (v.includes(item.en) || v.includes(item.ar)) { match = true; break; }
      }
      if (!match) return;

      if (!node.__mm_en) node.__mm_en = v;
      const next = toAr ? translate(node.__mm_en, true) : node.__mm_en;
      if (node.nodeValue !== next) node.nodeValue = next;
    });

    walkDeep(document.documentElement, (node) => {
      if (node.nodeType !== 1 || !node.getAttribute) return;
      const textAttr = node.getAttribute("text");
      if (!textAttr) return;

      let match = false;
      for (const item of MAP) {
        if (textAttr.includes(item.en) || textAttr.includes(item.ar)) { match = true; break; }
      }
      if (!match) return;

      if (!node.dataset.mmTextEn) node.dataset.mmTextEn = textAttr;
      const next = toAr ? translate(node.dataset.mmTextEn, true) : node.dataset.mmTextEn;
      if (node.getAttribute("text") !== next) node.setAttribute("text", next);
    });
  }

  let t = null;
  function schedule() {
    if (t) return;
    t = setTimeout(() => { t = null; try { apply(); } catch(e) {} }, 120);
  }

  document.addEventListener("DOMContentLoaded", () => {
    schedule();
    new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ["class"] });
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  });
})(); 


// Changes Shop Now to Add to cart In Cart Popup
$(document).on('click', '.m-product-quickview-button', function() {
  setTimeout(function() {
    $(".m-product-quickview--info .m-product-form .m-add-to-cart").html("Add to Cart");
  }, 1000);
});




// For Opening Reviews Collapsible on clicking Stars ratings 

document.addEventListener('DOMContentLoaded', function() {
  document.querySelector('#shopify-block-AeWRmdkpCb054aHZOR__judge_me_reviews_preview_badge_XDpkQN')
    .addEventListener('click', function() {
      setTimeout(function() {
        var btn = document.querySelector("collapsible-tab[data-block-id='collapsible-tab-collapsible_tab_6gLiMP'] [data-trigger]");
        if (btn) {
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          if (!isOpen) btn.click();
          setTimeout(function() {
            btn.closest('collapsible-tab').scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 300);
        }
      }, 300);
    }, true); // 👈 capture true
});



$(document).ready(function(){
   $(".template-product.custom-single-product product-info .m-add-to-cart.m-spinner-button").html("Add to Cart");
})
















